import { Components, Theme } from "@mui/material";

export const MuiDivider: Components<Omit<Theme, "MuiDivider">>["MuiDivider"] = {
  styleOverrides: {
    root: {
      borderColor: "#00000014",
    },
  },
};
